import * as React from "react";
const SvgRefreshWhiteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M10 2.133c-3.212 0-5.833 2.622-5.833 5.834v3.821l-.661-.66a.832.832 0 0 0-1.413.752c.034.162.116.31.235.426l2.009 2.01a.833.833 0 0 0 1.33-.004l2.006-2.006a.834.834 0 1 0-1.179-1.178l-.66.66V7.967A4.154 4.154 0 0 1 10 3.8c.91 0 1.742.292 2.43.787a.833.833 0 1 0 .974-1.352A5.814 5.814 0 0 0 10 2.133Zm4.988 3.322a.834.834 0 0 0-.652.33l-2.008 2.01a.833.833 0 1 0 1.178 1.178l.66-.661v3.821A4.154 4.154 0 0 1 10 16.3c-.91 0-1.742-.292-2.43-.787a.831.831 0 0 0-1.173.18.833.833 0 0 0 .199 1.172A5.814 5.814 0 0 0 10 17.967c3.212 0 5.833-2.622 5.833-5.834V8.312l.661.66a.833.833 0 1 0 1.179-1.178L15.66 5.782a.834.834 0 0 0-.673-.327Z"
    />
  </svg>
);
export default SvgRefreshWhiteIcon;
